/**
 * Filter for media queries
 * @link https://github.com/jacopotarantino/angular-match-media
 */
(function (itxApp) {

    'use strict';

    angular.module('itxApp.common').filter('media', ItxScreenSizeFlt);

    ItxScreenSizeFlt.$inject = ['ItxScreenSizeSvc'];

    function ItxScreenSizeFlt(ItxScreenSizeSvc) {
        var mediaFilter = function (inputValue, options) {
            // Get actual size
            var size = ItxScreenSizeSvc.get();

            // Variable for the value being return (either a size/rule name or a group name)
            var returnedName = '';

            if (!options) {
                // Return the size/rule name
                return size;
            }

            // Replace placeholder with group name in input value
            if (options.groups) {
                for (var prop in options.groups) {
                    if (options.groups.hasOwnProperty(prop)) {
                        var index = options.groups[prop].indexOf(size);
                        if (index >= 0) {
                            returnedName = prop;
                        }
                    }
                }

                // If no group name is found for size use the size itself
                if (returnedName === '') {
                    returnedName = size;
                }
            }

            // Replace or return size/rule name?
            if (options.replace && typeof options.replace === 'string' && options.replace.length > 0) {
                return inputValue.replace(options.replace, returnedName);
            } else {
                return returnedName;
            }
        };

        // Since AngularJS 1.3, filters which are not stateless (depending at the scope)
        // have to explicit define this behavior.
        mediaFilter.$stateful = true;
        return mediaFilter;
    }

    /** Public */
    itxApp.common.ItxScreenSizeFlt = ItxScreenSizeFlt;

})(window.itxApp);
